// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"style__buttonWrapper__qlzP5","background":"style__background__3EKG2"};